module.exports = __webpack_public_path__ + "img/iso_50001.b65c2178.jpg";